import React, { useEffect, useState } from 'react';
import './Ribbon.scss';
import DOMPurify from 'dompurify';

interface RibbonProps {
  borderColor: string;
  textColor: string;
  flashCount: number;
  display: boolean;
  text: string;
  backgroundColor: string;
}

const Ribbon: React.FC<RibbonProps> = ({ backgroundColor, borderColor, textColor, flashCount, display, text }) => {
  const [flashes, setFlashes] = useState(0);
  const [isFlashing, setIsFlashing] = useState(true);
  const [isVisible, setIsVisible] = useState(display);

  useEffect(() => {
    if (display && flashes < flashCount) {
      const interval = setInterval(() => {
        setFlashes(prev => prev + 1);
      }, 1000);

      return () => clearInterval(interval);
    } else if (flashes >= flashCount) {
      setIsFlashing(false);
    }
  }, [display, flashes, flashCount]);

  const handleDismiss = () => {
    setIsVisible(false);
  };
  // const sanitizedContent = DOMPurify.sanitize(text);

  return (
    <div
      className={`ribbon ${!isVisible ? 'hidden' : ''} ${!isFlashing ? 'centered' : ''}`}
      style={{ 
        backgroundColor, 
        borderColor, 
        color: textColor, 
        animation: isFlashing ? 'flash 1s infinite' : 'none' 
      }}
    >
      <div  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }}></div>
      {!isFlashing && (
        <button className="dismiss-button" onClick={handleDismiss}>
          Dismiss
        </button>
      )}
    </div>
  );
};

export default Ribbon;
